/* eslint-disable import/prefer-default-export */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAccountMapping } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useDeleteAccountMapping() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteAccountMapping(id),
    onSuccess: () => {
      queryClient.invalidateQueries(userQueryKeys.accountMappings({}).slice(0, 1));
    },
  });
}
